import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import Overview from "@/components/landing/Overview";
import Features from "@/components/landing/Features";
import Tutorial from "@/components/landing/Tutorial";
import FAQ from "@/components/landing/FAQ";
import Contact from "@/components/landing/Contact";
import FinalCTA from "@/components/landing/FinalCTA";
import Footer from "@/components/landing/Footer";

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-[#050505] text-white antialiased" data-testid="landing-page">
      <Navbar />
      <main>
        <Hero />
        <Overview />
        <Features />
        <Tutorial />
        <FAQ />
        <Contact />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
